//Template config options
import DETAILS from "@constants/shopDetails";
import {DynamicMedia} from "@assets/data/media/index.jsx";

const env = window.__ENV__ || import.meta.env;
const themeConfig = {
    themeId: env.VITE_REACT_APP_THEME_ID,
    app: {
        appName: DETAILS.name,
        appLogoImage: DynamicMedia.logo
    },
    layout: {
        isRTL: true,
        skin: 'light', // light, dark, bordered, semi-dark
        routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
        type: 'vertical', // vertical, horizontal
        contentWidth: 'full', // full, boxed
        menu: {
            isHidden: false,
            isCollapsed: false
        },
        navbar: {
            // ? For horizontal menu, navbar type will work for navMenu type
            type: 'floating', // static , sticky , floating, hidden
            backgroundColor: 'white' // BS color options [primary, success, etc]
        },
        footer: {
            type: 'static' // static, sticky, hidden
        },
        customizer: false,
        scrollTop: false // Enable scroll to top button
    }
}

export default themeConfig;
